import React from 'react';
import { FilePlus, User } from 'react-feather';
import { LandLordKeyIcon } from '@/components/ui';
import Agent from '@/views/lease/components/Agent';
import { translateLanguage } from '@/core/utils';

const AgentSigning = ({ agent }) => (
  <div className="card card-with-shadow border-0 padding-30">
    <div className="row">
      <div className="col-md-8 col-xl-8 col-xxl-8 col-xxxl-9 padding-lr-40">
        <div className="d-flex flex-column justify-content-between h-100">
          <h6 className="montserrat-600 font-18 text-faded-black text-center margin-t-20">
            {translateLanguage('leases.the_assignment_is_being_created_and_soon')} <br />
            {translateLanguage('leases.ready_for_you_to_sign')}
          </h6>

          <div className="d-flex align-items-center stepProgress">
            <div className="stepProgress__container">
              <div className="stepProgress__bar" id="progress" style={{ width: `0%` }} />

              <div className="stepProgress__circle stepProgress__circle--active">
                <FilePlus />
              </div>

              <div className="stepProgress__circle">
                <User />
              </div>

              <div className="stepProgress__circle svg-icon-25">
                <LandLordKeyIcon />
              </div>

              <div className="stepProgress__text">
                <span className="montserrat-500 font-14 text-faded-black">
                  {translateLanguage('leases.agent_e_signing')}
                </span>
                <span className="montserrat-500 font-14 text-faded-black">
                  {translateLanguage('leases.landlord_e_signing')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Agent agent={agent} />
    </div>
  </div>
);

export default AgentSigning;
